import CookiesJS from 'cookies-js';

export function initPayments($, apiClient) {
    $('form.payment-form .action__entity-save').on('click', async function () {
        try {
            const payment = {
                amount: $('#amount').val(),
                paymentIntegration: 'manualPayment',
                deleted: !!$('#deleted').prop('checked'),
            };
            const result = await apiClient.create(`/users/${$('#userId').val()}/payments`, payment, CookiesJS.get('auth_token'));
            console.log(result);
            document.location.href=`/payments/edit/${result._id}`;
        } catch (e) {
            console.warn(e);
            if (e.response
                && e.response.data
                && e.response.data.errors
                && e.response.data.errors[0]
                && e.response.data.errors[0].msg
            ) {
                alert(`${e.response.data.errors[0].msg}: ${e.response.data.errors[0].param}`);
            } else {
                alert(e);
            }
        }
    });
}
